var render = function render(){var _vm=this,_c=_vm._self._c;return _c('McButton',{attrs:{"variant":"secondary","text":_vm.$t('global.back'),"icon":"icon-outline_arrow-left"},on:{"click":_vm.goBack}})
}
var staticRenderFns = []

export { render, staticRenderFns }